import { LoginFormContainer } from "@platform/features/auth";
import { useLoginRedirect } from "@platform/hooks/useLoginRedirect";
import { AuthPageContent } from "@themes/pollinator/ui/AuthPageContent";

export function LoginPage() {
  const { redirect } = useLoginRedirect();

  const handleSuccess = async (data: any) => {
    await redirect(data);
  };

  return (
    <div className="flex-1 flex flex-col justify-between bg-brand-50 text-brand-800">
      <AuthPageContent
        title="Log in to your account"
        description="Welcome back."
      >
        <LoginFormContainer onSuccess={handleSuccess} />
      </AuthPageContent>
    </div>
  );
}

export default LoginPage;
